import { IBlock } from 'common/builder/blocks/blockInterfaces'
import { parseConditions } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converterRules/helpers/parseConditions'
import { FlowChartNextStepBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartNextStepBuilder'
import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { FlowChartConditionGroup } from 'common/builder/components/chart/FlowChart/types/FlowChartNode/FlowChartConditionNode'
import { BlockType } from 'common/builder/constants/BlockType'
import { ISegmentItem } from 'common/core/interfaces/segmentItem'
import { Field } from 'common/fields/entities/field'
import { NotificationReason } from 'shared/api/requests/notificationReason/schemas'

export interface GetConditionNodeConditionGroupsPayload {
  timezone: string | null
  fields: Field[]
  segments: Record<string, ISegmentItem>
  notificationReasons: NotificationReason[]
}

export function getConditionNodeConditionGroup({
  block,
  timezone,
  fields,
  segments,
  notificationReasons,
}: {
  block: IBlock
} & GetConditionNodeConditionGroupsPayload): FlowChartConditionGroup | null {
  if (block.type !== BlockType.CASE) {
    return null
  }

  const conditions = parseConditions(block.filter, {
    botTimezone: timezone,
    fields,
    segments,
    activeReasons: notificationReasons,
  })
  const shouldShow = conditions.length > 0 || block.targetId

  if (!shouldShow) {
    return null
  }

  return {
    conditions,
    nextStep: new FlowChartNextStepBuilder(block.id).withColor(sharedStyles.Colors.CYAN_40).build(),
  }
}
